import type { ICarousel } from './lightbox-modal.service'

import { app } from '../../app.module'

class LightboxModalComponentCtrl {
  private mdDialog: {
    hide: Function
  }
  private snsType: string
  private accountId: number
  private postId: number
  private postType: string
  private thumbnailUrl: string
  private totalMedia: number
  private carouselList: ICarousel[]
  private imageShow: string
  private embedLink: string
  private currentCarouselIndex: number
  private iframeWidth: number
  private iframeHeight: number
  // media表示用のelementタグ(img or video or iframe)
  private showTag: string

  constructor(
    $scope,
    $mdDialog,
    private LightboxModalService
  ) {
    this.mdDialog = $mdDialog
    this.carouselList = []
    this.currentCarouselIndex = 0
    this.showTag = 'img'
    this.iframeWidth = 853
    this.iframeHeight = 480
  }

  /**
   * 初期化
   */
  public $onInit(): void {
    if (this.snsType === 'facebook') {
      this.setFacebookMedia()
    } else {
      switch (this.postType) {
        // 動画またはアニメションGIF投稿の場合
        case 'video':
        case 'live-video':
        case 'animation-gif':
          this.setIframeSrc()
          break

        // 画像またはアルバムの場合、画像リストを取得して表示
        case 'photo':
        case 'album':
          if (this.snsType === 'line' && this.totalMedia === 1) {
            this.imageShow = this.thumbnailUrl
            this.showTag = 'img'
            return
          }
          this.LightboxModalService.getPostImagesList(this.postId, this.snsType).then(
            (imagesList) => {
              this.carouselList = imagesList
              this.setCurrentCarousel()
            }
          )
          break
        case 'carousel':
          if (this.snsType === 'instagram' || this.snsType === 'tiktok') {
            this.LightboxModalService.getCarousel(this.postId, this.snsType).then(
              (carouselList) => {
                this.carouselList = carouselList
                this.setCurrentCarousel()
              }
            )
          } else {
            this.imageShow = this.thumbnailUrl
          }
          break

        // 上記のケース以外の場合、投稿のサムネイルとして表示
        default:
          this.imageShow = this.thumbnailUrl
      }
    }
  }

  /**
   * Iframeのsrcをセット
   */
  public setIframeSrc() {
    switch (this.snsType) {
      case 'facebook':
        this.LightboxModalService.getPostVideo(this.accountId, this.postId, this.snsType).then(
          (videoInfo) => {
            // 動画がある場合、動画URLをセット
            if (videoInfo !== null) {
              this.showTag = videoInfo.showType
              switch (videoInfo.showType) {
                // 表示タイプがiframeの場合
                case 'iframe':
                  this.iframeWidth = videoInfo.width
                  this.iframeHeight = videoInfo.height
                  this.embedLink = videoInfo.videoUrl
                  break

                // 表示タイプがvideoの場合
                case 'video':
                  this.embedLink = videoInfo.videoUrl
                  break

                // 表示タイプがimgの場合
                case 'img':
                  this.imageShow = this.thumbnailUrl
                  break
              }
            } else {
              // 動画がない場合、動画サムネイルとして表示
              this.imageShow = this.thumbnailUrl
            }
          }
        )
        break

      case 'twitter':
      case 'instagram':
        this.LightboxModalService.getPostVideo(this.accountId, this.postId, this.snsType).then(
          (videoUrl) => {
            // 動画がある場合、動画URLをセット
            if (videoUrl) {
              this.embedLink = videoUrl
              this.showTag = 'video'
            } else {
              // 動画がない場合、動画サムネイルとして表示
              this.imageShow = this.thumbnailUrl
            }
          }
        )
        break

      case 'youtube':
        this.embedLink =
          'https://www.youtube.com/embed/' + this.postId + '?iv_load_policy=3&showinfo=0'
        this.showTag = 'iframe'
        break
      case 'line':
        this.embedLink = this.thumbnailUrl.replace('/L800x800', '.mp4')
        this.showTag = 'video'
        break
      case 'tiktok':
        this.embedLink = `https://www.tiktok.com/static/profile-video?id=${this.postId}&hide_author=1&utm_campaign=tt4d_open_api`
        this.showTag = 'iframe'
        break
    }
  }

  /**
   *  選択中の画像から次の画像に切り替え
   */
  public nextImage() {
    this.currentCarouselIndex = this.currentCarouselIndex + 1
    this.setCurrentCarousel()
  }

  /**
   *  選択中の画像から前の画像に切り替え
   */
  public previousImage() {
    this.currentCarouselIndex = this.currentCarouselIndex - 1
    this.setCurrentCarousel()
  }

  /**
   * Dialogを閉じる
   */
  public close() {
    this.mdDialog.hide()
  }

  /**
   * 現在表示カルーセルをセット
   */
  private setCurrentCarousel(): void {
    // カルーセルの場合は、現在表示カルーセルをセット
    if (this.postType === 'carousel') {
      const currentCarousel = this.carouselList[this.currentCarouselIndex]

      if (!currentCarousel) {
        this.imageShow = this.thumbnailUrl
        return
      }

      if (currentCarousel.type === 'video') {
        this.embedLink = currentCarousel.videoUrl
        this.showTag = 'video'
      } else {
        this.imageShow = currentCarousel.imageUrl
        this.showTag = 'img'
      }
    } else {
      // カルーセルではない場合は、画像をセット
      this.showTag = 'img'
      this.imageShow = this.carouselList[this.currentCarouselIndex].imageUrl
    }
  }

  /**
   * Facebookのmedia表示をセット
   */
  private setFacebookMedia() {
    switch (this.postType) {
      case 'video':
      case 'live-video':
      case '360-video':
      case 'animation-gif':
        this.setIframeSrc()
        break
      case 'link':
      case 'carousel':
        this.LightboxModalService.getLinkPostImage(this.postId, this.snsType)
          .then((image) => {
            this.imageShow = image !== '' ? image : this.thumbnailUrl
          })
          .catch(() => {
            this.imageShow = this.thumbnailUrl
          })
        break
      // 上記のケース以外の場合、投稿のサムネイルとして表示
      default:
        this.LightboxModalService.getPostImagesList(this.postId, this.snsType)
          .then((imagesList) => {
            if (imagesList && imagesList.length > 0) {
              this.carouselList = imagesList
              this.setCurrentCarousel()
            } else {
              this.imageShow = this.thumbnailUrl
            }
          })
          .catch(() => {
            this.imageShow = this.thumbnailUrl
          })
    }
  }
}

app.component('lightboxModal', {
  bindings: {
    snsType: '@',
    accountId: '@',
    postId: '@',
    postType: '@',
    thumbnailUrl: '@',
    postLinkUrl: '@',
    totalMedia: '<',
  },
  template: require('./post-table-picture.pug')(),
  controller: LightboxModalComponentCtrl,
})
